import { useTranslation } from "next-i18next";

import { SalesLayoutHeader } from "components/SalesLayoutHeader";
import { DealState, SharedOpportunityStatus } from "common/middleware/api.services";
import { usePurchaseOffers } from "common/api/getPurchaseOffers";
import { useSharedOpportunities } from "common/api/getSharedOpportunities";
import {
  useLoggedInUserListings,
  ListingStates,
} from "api/getLoggedInUserListings";

export const ListingsIndexPageHeader = () => {
  const { t } = useTranslation("admin");
  const { listings, isLoading: isListingsLoading } = useLoggedInUserListings({
    filterByListingStates: ListingStates.published,
  });
  const { opportunities, isOpportunitiesLoading } = useSharedOpportunities({
    stateFilters: [SharedOpportunityStatus.Browsing, SharedOpportunityStatus.Offer],
  });
  const { purchaseOffers: firmDeals, isPurchaseOffersLoading: isFirmDealsLoading } = usePurchaseOffers({ states: [DealState.Firm] });
  const { purchaseOffers: cancelledOffers, isPurchaseOffersLoading: isCancelledOffersLoading } = usePurchaseOffers({ states: [DealState.Cancelled] });

  const isLoading = isOpportunitiesLoading
    || isFirmDealsLoading
    || isCancelledOffersLoading
    || isListingsLoading;

  return (
    <SalesLayoutHeader
      contents={[
        {
          title: t("listingsIndexPageHeader.totalListings"),
          content: listings?.count,
        },
        {
          title: t("listingsIndexPageHeader.totalOpportunities"),
          content: opportunities?.totalNumOfOpportunities,
        },

        {
          title: t("listingsIndexPageHeader.totalFirm"),
          content: firmDeals?.count,
        },
        {
          title: t("listingsIndexPageHeader.totalCancelled"),
          content: cancelledOffers?.count,
        },
      ]}
      isContentsLoading={isLoading}
      licenseType="unlicensed"
    />
  )
}
